/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "נעכטן",
        "0": "היינט",
        "1": "מארגן",
        "future": {
          "one": "אין {0} טאָג אַרום",
          "other": "אין {0} טעג אַרום"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-narrow": {
        "-1": "נעכטן",
        "0": "היינט",
        "1": "מארגן",
        "future": {
          "one": "אין {0} טאָג אַרום",
          "other": "אין {0} טעג אַרום"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-short": {
        "-1": "נעכטן",
        "0": "היינט",
        "1": "מארגן",
        "future": {
          "one": "אין {0} טאָג אַרום",
          "other": "אין {0} טעג אַרום"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "month": {
        "-1": "פֿאַרגאנגענעם חודש",
        "0": "דעם חודש",
        "1": "קומענדיקן חודש",
        "future": {
          "one": "איבער {0} חודש",
          "other": "איבער {0} חדשים"
        },
        "past": {
          "one": "פֿאַר {0} חודש",
          "other": "פֿאַר {0} חדשים"
        }
      },
      "month-narrow": {
        "-1": "פֿאַרגאנגענעם חודש",
        "0": "דעם חודש",
        "1": "קומענדיקן חודש",
        "future": {
          "one": "איבער {0} חודש",
          "other": "איבער {0} חדשים"
        },
        "past": {
          "one": "פֿאַר {0} חודש",
          "other": "פֿאַר {0} חדשים"
        }
      },
      "month-short": {
        "-1": "פֿאַרגאנגענעם חודש",
        "0": "דעם חודש",
        "1": "קומענדיקן חודש",
        "future": {
          "one": "איבער {0} חודש",
          "other": "איבער {0} חדשים"
        },
        "past": {
          "one": "פֿאַר {0} חודש",
          "other": "פֿאַר {0} חדשים"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "איבער אַכט טאָג",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "איבער אַכט טאָג",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "איבער אַכט טאָג",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "year": {
        "-1": "פֿאַראַיאָר",
        "0": "הײַ יאָר",
        "1": "איבער א יאָר",
        "future": {
          "one": "איבער {0} יאָר",
          "other": "איבער {0} יאָר"
        },
        "past": {
          "one": "פֿאַר {0} יאָר",
          "other": "פֿאַר {0} יאָר"
        }
      },
      "year-narrow": {
        "-1": "פֿאַראַיאָר",
        "0": "הײַ יאָר",
        "1": "איבער א יאָר",
        "future": {
          "one": "איבער {0} יאָר",
          "other": "איבער {0} יאָר"
        },
        "past": {
          "one": "פֿאַר {0} יאָר",
          "other": "פֿאַר {0} יאָר"
        }
      },
      "year-short": {
        "-1": "פֿאַראַיאָר",
        "0": "הײַ יאָר",
        "1": "איבער א יאָר",
        "future": {
          "one": "איבער א יאָר",
          "other": "איבער {0} יאָר"
        },
        "past": {
          "one": "פֿאַר {0} יאָר",
          "other": "פֿאַר {0} יאָר"
        }
      }
    },
    "locale": "yi"
  });
}